import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';

/**
 * Epoch ms until this chat may send again after a rate-limit refusal.
 * Keyed by the chat state key (`chat-<id>`, `session-<id>-new`, or `sessionless`).
 */
export const chatCooldownUntilAtomFamily = atomFamily(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (_stateKey: string) => atom<number | null>(null)
);
